(ns splash.ui.lender-portal.views.pages.document-viewer
  (:require
    ["@azure/msal-react" :refer [useMsal]]
    ["react-router-dom" :refer [useParams]]
    ["react-zoom-pan-pinch" :refer [useControls]]
    [reagent.core :as r]
    [splash.ui.lender-portal.common.auth :as auth]
    [splash.ui.lender-portal.common.request :as request]
    [splash.ui.lender-portal.common.util :as util]
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.zoom-pan-pinch :as zoom-pan-pinch]
    [splash.ui.lender-portal.datadog :as datadog]
    [splash.ui.lender-portal.state :as state]))

(def current-document (r/atom nil))

(defn control-button
  [label handler]
  [mui/button {:on-click #(handler)
               :sx {:padding "4px 12px"
                    :background "white"
                    :border "1px solid grey"
                    :border-radius "5px"
                    :margin-right "10px"
                    :text-transform "uppercase"
                    :font-size "10px"
                    :color "black"
                    :font-weight 600
                    "&:hover" {:background "#F0F0F0"}}} label])

(defn image-wrapper
  [url]
  (r/with-let [controls (useControls)
               {:strs [zoomIn zoomOut resetTransform centerView]} (js->clj controls)
               deg (r/atom 0)]
    [:<>
     [mui/stack {:direction      :row
                 :spacing        1
                 :justifyContent :center
                 :alignItems     :center
                 :pt             1
                 :pl             1
                 :width          "100vw"}
      [control-button "Zoom In +" zoomIn]
      [control-button "Zoom Out -" zoomOut]
      [control-button "Reset" resetTransform]
      [control-button "Center" centerView]
      [control-button "Rotate Right" (fn [] (swap! deg + 90))]
      [control-button "Rotate Left" (fn [] (swap! deg - 90))]]
     [zoom-pan-pinch/transform-component
      {:wrapperStyle {:width  "100vw"
                      :height "95.5vh"}}
      [:img {:src   url
             :style {:width     "100%"
                     :transform (str "rotate(" @deg "deg)")}}]]]))

(defn document-viewer
  []
  (r/with-let [msal-instance (.-instance (useMsal))
               state (state/use-state)
               loading (r/cursor state [:loading])
               params (useParams)
               application-id (-> ^js/String (.-applicationId params)
                                parse-long)
               document-id (-> ^js/String (.-documentId params)
                             parse-long)
               handle-result (fn [result]
                               (reset! loading false)
                               (let [application (js->clj result)
                                     documents (:website-documents application)]
                                 (reset! current-document (->> documents
                                                            (filter #(= document-id (:id %)))
                                                            first))))
               mk-get-application-request (fn [application-id token]
                                            (request/mk-json-request
                                              {:uri (str "/api/v1/applications/" application-id)
                                               :token token
                                               :method :get
                                               :handler handle-result
                                               :error-handler (fn [e]
                                                                (datadog/report-error
                                                                  (str "Failed to open document " document-id)
                                                                  e
                                                                  {:application-id application-id
                                                                   :document-id document-id})
                                                                (handle-result nil))}))
               on-load (fn []
                         (reset! current-document nil)
                         (reset! loading true)
                         (-> (auth/acquire-token msal-instance)
                           (.then (partial mk-get-application-request application-id))))]
    (r/create-class
      {:component-did-mount on-load
       :reagent-render
       (fn []
         (when @current-document
           (let [file-type (util/get-file-type (:original-filename @current-document) (:mime-type @current-document))
                 url (:url @current-document)]
             (if (= :image file-type)
               [:div
                {:class "dd-privacy-mask"}
                [zoom-pan-pinch/transform-wrapper
                 {:initialScale    1
                  :centerZoomedOut true
                  :centerOnInit    true}
                 [image-wrapper url]]]
               [:embed {:src   url
                        :width "100%"
                        :height "100%"}]))))})))

(defn view
  []
  (r/with-let [state (state/use-state)
               loading (r/cursor state [:loading])]
    [mui/grid {:container true :style {:height "100vh"}}
     [mui/backdrop {:open @loading
                    ;; overlay should cover everything,
                    ;; but for some reason DataGrids are 
                    ;; rendering over the backdrop
                    :sx {:z-index 999}}
      [mui/circular-progress]]
     [document-viewer]]))
